import { formatDate } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, Output, EventEmitter, OnInit, TemplateRef, ViewChild  } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ApiService } from 'src/app/services/api.service';
import { StorageService } from 'src/app/services/storage.service';
import { NgxSpinnerService } from "ngx-spinner";
import { MatDialog } from '@angular/material/dialog';
export interface JsonFormControls {
  id: string;
  form_id: number;
  field: string;
  type: string;
  name: string;
  class: string;
  label: string;
  element_id: string;
  placeholder: string;
  multiple: boolean;
  is_dynamic: boolean;
  is_boolean: boolean;
  position: number;
  validators: JsonFormValidators;
  values: Value[];
  dynamic_url?: string;
  has_conditional: boolean,
  is_conditional: boolean,
  has_conditional_details?: {
    has_conditional_name: string,
    has_conditional_value: string;
  };
  conditional_details?: {
    conditional_name: string,
    conditional_value: string;
  },
  expiration_details?: {
    expiration_no: number,
    expiration_type: string;
  };
}

export interface JsonFormValidators {
  required?: string;
  regex?: string;
  maxsize?: number;
  accept?: string;
}

export interface Value {
  value: string;
  label: string;
}
export type JsonFormData = JsonFormControls[];

@Component({
  selector: 'app-custom-form',
  templateUrl: './custom-form.component.html',
  styleUrls: ['./custom-form.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class CustomFormComponent implements OnInit {
  hide = true;
  @Input() jsonFormData!: JsonFormData;
  @Input() totalCount = 1;
  @Input() editFormData: any;
  @Input() country = '';
  @Input() requiredHtml = '';
  @Output() formValue = new EventEmitter<any>();
  public dynamicForm: FormGroup = this.fb.group({});
  countArray: any;
  step = 0;
  passportMinDate = new Date();
  passportError = "";
  fileNames: any;
  conditionalFields: any;
  editFileNames: any[] = [];
  dateOfBirths: any[] = [];
  bookingDetails: any;
  countValidationErrorMsg = "";
  formError = "";
  ocrData: Object = {};
  isChecked = false;
  @ViewChild('ocrDialog') ocrDialogCall!: TemplateRef<any>;

  constructor(public dialog: MatDialog, private fb: FormBuilder, private storage: StorageService, private apiService: ApiService, private spinner: NgxSpinnerService) { }

  setStep(index: number) {
    this.step = index;
  }

  nextStep() {
    this.step++;
  }

  prevStep() {
    this.step--;
  }

  isFieldRequired(control: any, index: any, controlIndex: any) {
    if (control.is_conditional) {
      let rawValue = this.dynamicForm.getRawValue();
      let applicantObj = Object.assign({}, ...rawValue[`applicant${index}`]);
      let conditional_ctrl_value = applicantObj[control.conditional_details.conditional_name] instanceof Array == false ? applicantObj[control.conditional_details.conditional_name] : null;
      //Checking Conditional value
      if (conditional_ctrl_value && this.checkString(conditional_ctrl_value) == this.checkString(control.conditional_details.conditional_value)) {
        return true;
      } else {
        return false;
      }
    }
    else {
      if (control.validators.required)
        return true;
      else
        return false;
    }

  }

  displayIsFileFieldRequiredAndValid(control: any, index: any, controlIndex: any) {
    const formCtrls = <FormArray>this.dynamicForm.controls[`applicant${index}`];
    var arrayControl = formCtrls.controls[controlIndex] as FormArray;
    if (control.validators.required && !arrayControl.get(control.name)?.valid && this.dynamicForm.touched)
      return true;
    else
      return false;

  }

  createForm(controls: JsonFormControls[]) {
    this.countArray.forEach((element: any, index: any) => {
      for (const control of controls) {
        const validatorsToAdd = [];
        for (const [key, value] of Object.entries(control.validators)) {
          switch (key) {
            case 'min':
              validatorsToAdd.push(Validators.min(value));
              break;
            case 'max':
              validatorsToAdd.push(Validators.max(value));
              break;
            case 'required':
              if (value) {
                validatorsToAdd.push(Validators.required);
              }
              break;
            case 'regex':
              if (value) {
                validatorsToAdd.push(Validators.pattern(value));
              }
              break;
            case 'email':
              if (value) {
                validatorsToAdd.push(Validators.pattern(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/));
              }
              break;
            case 'minLength':
              validatorsToAdd.push(Validators.minLength(value));
              break;
            case 'maxLength':
              validatorsToAdd.push(Validators.maxLength(value));
              break;
            case 'pattern':
              validatorsToAdd.push(Validators.pattern(value));
              break;
            case 'nullValidator':
              if (value) {
                validatorsToAdd.push(Validators.nullValidator);
              }
              break;
            default:
              break;
          }
        }
        const dynamicControl = <FormArray>this.dynamicForm.controls[`applicant${index}`];
        dynamicControl.push(this.getApplicant(control.name, "", validatorsToAdd));
      }
    });;

    //Updated Edit logic to accommodate new fields 
    if (this.editFormData?.form_elements.length > 0) {
      let editArray: any[] = [];
      for (const control of controls) {
        let formControl = this.editFormData.form_elements.filter((x: any) => x.field_name == control.name);
        if (formControl.length > 0) {

          if (formControl[0].field_type === "date") {
            let date1 = formControl[0].field_value.split('-');
            let convertedDate = new Date(date1[1] + '-' + date1[0] + '-' + date1[2]);
            editArray.push(this.getEditValue(formControl[0].field_name, convertedDate));
          } else if (formControl[0].field_type === "file") {
            this.editFileNames.push({
              name: formControl[0].field_name,
              url: formControl[0].field_value == "" ? "" : formControl[0].field_value,
              extension: formControl[0].field_value == "" ? "" : formControl[0].field_value.split(".").pop(),
              fileName: formControl[0].field_value == "" ? "" : new URL(formControl[0].field_value).pathname.split('/').pop(),
              isVisible: formControl[0].field_value == "" ? false : true
            });
            editArray.push(this.getEditValue(formControl[0].field_name, formControl[0].field_value));

          } else {
            editArray.push(this.getEditValue(formControl[0].field_name, formControl[0].field_value));
          }

        } else {
          editArray.push(this.getEditValue(control.name, ''));
        }
      }
      this.dynamicForm.get('applicant0')?.patchValue(editArray);
    }




  }

  getEditValue(controlName: any, controlValue: any) {
    let obj: any = {};
    obj[controlName] = controlValue;
    return obj;
  }

  getApplicant(controlName: any, controlValues: any, validatorsToAdd: any) {
    let obj: any = {};
    obj[controlName] = [controlValues, validatorsToAdd];
    return this.fb.group(
      obj
    );
  }

  toggleUpload(control: any, i: number) {
    if (this.editFormData?.form_elements.length > 0) {
      this.editFileNames.map((el: any, index: number) => {
        if (el.name == control.name) {
          el.isVisible = !el.isVisible;
        }
      });
    }
    const passportControl = <FormArray>this.dynamicForm.controls[`applicant0`];
    passportControl.controls[i].reset();
  }

  validateApplicantCount(applicants: any[]) {

    let childrenCount = applicants.filter(x => x.ischild && x.ischild == "Yes").length;
    let adultCount = applicants.filter(el => el.ischild && el.ischild == "No").length;
    if (Object.keys(this.bookingDetails).length > 0) {
      if (this.bookingDetails.no_of_adults != adultCount && childrenCount != this.bookingDetails.no_of_childs) {
        return false;
      }
    }
    return true;
  }

  onSubmit(model: any, isValid: boolean, e: any) {
    //For getting values of disabled inputs
    let rawValue = this.dynamicForm.getRawValue();
    this.formError = '';
    this.passportError = '';
    this.countValidationErrorMsg = '';

    if (!this.dynamicForm.valid) {
      this.formError = "Please fill out all the required fields and click 'Submit'.";
      return;
    }

    let applicantArray: any[] = [];
    for (const key in rawValue) {
      let applicantObj = Object.assign({}, ...rawValue[key]);
      applicantArray.push(applicantObj);
    }
    applicantArray.forEach((el: any) => {
      Object.entries(el).forEach(([key, value]) => {
        if (value instanceof Date) {
          el[`${key}`] = formatDate(value, 'dd-MM-yyy', 'en-US', '+0530');
        }
      });
    });
    if (!this.validateApplicantCount(applicantArray)) {
      this.countValidationErrorMsg = "Please verify the applicant details as the number of adults/children provided does not match the initial selection.";
      return;
    }

    let hasDuplicates = applicantArray.map(el => el.passportnumber).length > new Set(applicantArray.map(el => el.passportnumber)).size ? true : false;
    if (hasDuplicates) {
      this.passportError = "Error! Identical passport numbers found";
    } else {
      this.formValue.emit(applicantArray);
    }


  }

  counter(i: number) {
    return Array.from(Array(i).keys());
  }

  onFileSelected(event: any, control: any, index: any, controlIndex: any) {
    const file: File = event[0];
    if (file) {
      if (file.size <= (control.validators.maxsize * 1000000)) {
        let fileIndex = this.fileNames[index].findIndex((el: any) => el.name == control.name);
        let fileObj = this.fileNames[index].map((el: any, index: number) => {

          if (index == fileIndex) {
            return { name: control.name, value: file.name, isValidSize: true };
          } else {
            return el;
          }
        });
        this.fileNames[index] = fileObj;
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
          const formCtrls = <FormArray>this.dynamicForm.controls[`applicant${index}`];
          var arrayControl = formCtrls.controls[controlIndex] as FormArray;

          //Reading OCR data
          if (control.name == 'attachpassport') {
            this.spinner.show('passport');
            this.getOcrData(this.convertToIdfyString(reader.result), index);
          }
          //Resetting Form Validators
          //Setting initial value to 
          arrayControl.get(control.name)?.setValue(reader.result);
          arrayControl.get(control.name)?.updateValueAndValidity();
        };
      } else {
        const passportControl = <FormArray>this.dynamicForm.controls[`applicant${index}`];
        passportControl.get('attachpassport');
        let fileIndex = this.fileNames[index].findIndex((el: any) => el.name == control.name);
        let fileObj = this.fileNames[index].map((el: any, index: number) => {
          if (index == fileIndex) {
            return { name: control.name, value: 'invalid', isValidSize: false };
          } else {
            return el;
          }
        });
        this.fileNames[index] = fileObj;
      }

    }
  }

  convertToIdfyString(file: any): string {
    let commaIndex = file.indexOf(',');
    let resultString = file.substring(commaIndex + 1);
    return resultString;

  }

  //Getting OCR data
  // async getOcrData(file: File, index: number) {
  //   //Generating Token for OCR Data
  //   await this.apiService.getOCRToken(file).then((data: any) => {
  //     this.apiService.tokenOcr = data.access_token;
  //   });
  //   await this.apiService.getOCRData(file).then(async (data: any) => {
  //     if (data.hasOwnProperty('process_status')) {
  //       if (data['process_status'] == 'SUCCESS') {
  //         this.ocrData = data.parsed_result.extracted_info;
  //         this.populateOcrData(this.ocrData, index);
  //         this.spinner.hide('passport');
  //       } else {
  //         this.spinner.hide('passport');
  //       }
  //     } else if (data.hasOwnProperty('error')) {
  //       await this.clearPassportFields(index);
  //       await this.spinner.hide('passport');
  //     }
  //   });
  // }


  async getOcrData(file: any, index: number) {
    this.apiService.getIdfyData(file).then((response: any) => {
      if(response.data.status == "completed"){        
        if(!response.data.result.extraction_output.address){          
          this.openDialog('We are unable to read the address details from your passport. Please ensure that your uploaded image includes both the front and back sides of the passport.');          
          this.spinner.hide('passport');
          return;
        }
        if (!response.data.result.extraction_output.first_name) {
          this.openDialog('We are unable to read the details from your passport. Please ensure that your uploaded image includes both the front and back sides of the passport.');          
          this.spinner.hide('passport');
          return;
        }
        this.ocrData = response.data.result.extraction_output;
        this.populateOcrData(this.ocrData, index);
        this.openDialog('Please cross-verify all the autofilled data and ensure that it matches the information on your passport!');        
      }else{
        this.openDialog('We are unable to read the details from your passport. Please ensure that your uploaded image includes both the front and back sides of the passport.');       
      }
      this.spinner.hide('passport');
    }, (error: any) => {
        this.openDialog('We apologize for the inconvenience, but we are currently unable to read the details from your passport. To resolve this issue, please ensure that the image you uploaded includes both the front and back sides of the passport. If the problem persists, please reach out to our support team for assistance. Or you can manually enter your passport details');
        this.spinner.hide('passport');
    });
   
  }

  //Open Dialog
  openDialog(msg:string){
    this.dialog.open(this.ocrDialogCall, { height: '200px', width: '400px', data: { message: msg } });
  }

  async clearPassportFields(index: number) {
    let passportFields = ['givenname', 'surname', 'gender', 'passportnumber', 'dateofbirth', 'passportexpirydate', 'country'];
    passportFields.forEach((el: string) => {
      this.getArrayCtrlByCtrlIndex(index, el).patchValue(this.getEditValue(el, ''));
    });
  }

  fieldControlCheck(formIndex: number, controlIndex: number,): boolean {
    let formCtrl = <FormArray>this.dynamicForm.get(`applicant${formIndex}`);
    let fieldCtrl = formCtrl.controls[controlIndex] as FormArray;
    if (fieldCtrl.errors == null && fieldCtrl.invalid) {
      return true;
    } else {
      return false;
    }

  }

  //Populating OCR data
  populateOcrData(data: any, index: number) {
    
    //Checking if the OCR data and the Dynamic form JSON has the required properties and patching the values
    if (data.first_name && this.jsonFormData.some(el => el.name == 'givenname')) {
      this.getArrayCtrlByCtrlIndex(index, 'givenname').patchValue(this.getEditValue('givenname', data.first_name));
      this.getArrayCtrlByCtrlIndex(index, 'country').patchValue(this.getEditValue('country', "India"));
    }
    else if (!data.first_name) {
      this.getArrayCtrlByCtrlIndex(index, 'givenname').patchValue(this.getEditValue('givenname', ''));
    }


    if (data.last_name && this.jsonFormData.some(el => el.name == 'surname')) {
      this.getArrayCtrlByCtrlIndex(index, 'surname').patchValue(this.getEditValue('surname', data.last_name));
    }
    else if (!data.last_name) {
      this.getArrayCtrlByCtrlIndex(index, 'surname').patchValue(this.getEditValue('surname', ''));
    }


    if (data.gender && this.jsonFormData.some(el => el.name == 'gender')) {
      let arrayControl = this.getArrayCtrlByCtrlIndex(index, 'gender');
      if (data.gender.toUpperCase() == 'FEMALE') {
        arrayControl.patchValue(this.getEditValue('gender', 'Female'));
      } else if (data.gender.toUpperCase() == 'MALE') {
        arrayControl.patchValue(this.getEditValue('gender', 'Male'));
      } else {
        arrayControl.patchValue(this.getEditValue('gender', 'Unknown'));
      }
    }
    else if (!data.gender) {
      this.getArrayCtrlByCtrlIndex(index, 'gender').patchValue(this.getEditValue('gender', ''));
    }


    if (data.id_number && this.jsonFormData.some(el => el.name == 'passportnumber')) {
      this.getArrayCtrlByCtrlIndex(index, 'passportnumber').patchValue(this.getEditValue('passportnumber', data.id_number));
    }
    else if (!data.id_number) {
      this.getArrayCtrlByCtrlIndex(index, 'passportnumber').patchValue(this.getEditValue('passportnumber', ''));
    }


    if (data.date_of_birth && this.jsonFormData.some(el => el.name == 'dateofbirth')) {     
        this.getArrayCtrlByCtrlIndex(index, 'dateofbirth').patchValue(this.getEditValue('dateofbirth', this.convertOcrDate(data.date_of_birth)));   
        let dob = new Date(data.date_of_birth);
        let timeDiff = Math.abs(Date.now() - dob.getTime());
        let age = Math.floor((timeDiff / (1000 * 3600 * 24))/365.25);
        if(age<=11){
          this.getArrayCtrlByCtrlIndex(index, 'ischild').patchValue(this.getEditValue('ischild', 'Yes')); 
        } else{
          this.getArrayCtrlByCtrlIndex(index, 'ischild').patchValue(this.getEditValue('ischild', 'No')); 
        }
    }
    else if (!data.date_of_birth) {
      this.getArrayCtrlByCtrlIndex(index, 'dateofbirth').patchValue(this.getEditValue('dateofbirth', ''));
    }


    if (data.date_of_expiry && this.jsonFormData.some(el => el.name == 'passportexpirydate')) {     
        this.getArrayCtrlByCtrlIndex(index, 'passportexpirydate').patchValue(this.getEditValue('passportexpirydate', this.convertOcrDate(data.date_of_expiry)));      
    }
    else if (!data.date_of_expiry) {
      this.getArrayCtrlByCtrlIndex(index, 'passportexpirydate').patchValue(this.getEditValue('passportexpirydate', ''));
    }    

    if (data.address && this.jsonFormData.some(el => el.name == 'residentialaddressasshowninpassport')) {
        this.getArrayCtrlByCtrlIndex(index, 'residentialaddressasshowninpassport').patchValue(this.getEditValue('residentialaddressasshowninpassport', data.address));
    }
    else if (!data.address) {
      this.getArrayCtrlByCtrlIndex(index, 'residentialaddressasshowninpassport').patchValue(this.getEditValue('residentialaddressasshowninpassport', ''));
    }

    if(data.place_of_birth){      
      let toArray =  data.place_of_birth.split(",");
      this.getArrayCtrlByCtrlIndex(index, 'district').patchValue(this.getEditValue('district', toArray[0]));
      if (toArray[1]){
        this.getArrayCtrlByCtrlIndex(index, 'state').patchValue(this.getEditValue('state', toArray[1]));
      }
      
    }
  }

 


  // Converting the OCR date to Material Calendar date format
  convertOcrDate(date: string): Date {
    let date1 = date.split('/');
    let convertedDate = new Date(date1[1] + '-' + date1[2] + '-' + date1[0]);
    return convertedDate;
  }

  //Getting the control array of the fields required
  getArrayCtrlByCtrlIndex(index: number, controlName: string) {
    let formCtrl = <FormArray>this.dynamicForm.get(`applicant${index}`);
    let controlIndex = this.getControlIndexByFormData(controlName);
    let arrayControl = formCtrl.controls[controlIndex] as FormArray;
    return arrayControl;
  }

  //GetFieldIndexByFieldName
  getControlIndexByFormData(fieldName: string) {
    let fieldIndex = null;
    //IfEditing
    if (this.editFormData) {
      fieldIndex = this.editFormData?.form_elements.findIndex((el: any) => el.field_name == fieldName);
    }
    else {
      fieldIndex = this.jsonFormData.findIndex((el: any) => el.name == fieldName);
    }
    return fieldIndex;

  }

  disableOrEnablePregnantField(control: any, index: number, isDisable: boolean) {
    let pregnantFormControls = <FormArray>this.dynamicForm.controls[`applicant${index}`];
    let pregnantIndex = this.getControlIndexByFormData('pregnant');
    if (pregnantIndex) {
      let pregnantFieldControl = pregnantFormControls.controls[pregnantIndex] as FormArray;
      if (isDisable) {
        pregnantFieldControl.get(control.name)?.setValue('NA');
        pregnantFieldControl.get(control.name)?.disable();
      } else {
        pregnantFieldControl.get(control.name)?.enable();
      }
    }
  }

  controlVisibility(control: any, index: number, controlIndex: number) {
    let conditional_ctrl_value = null;
    if (control.is_conditional) {
      if (control.name == 'pregnant') {
        let rawValue = this.dynamicForm.getRawValue();
        let applicantObj = Object.assign({}, ...rawValue[`applicant${index}`]);
        let isChildValue = applicantObj['ischild'] instanceof Array == false ? applicantObj['ischild'] : null;
        if (this.checkString(isChildValue) == 'yes') {
          this.disableOrEnablePregnantField(control, index, true);
          return false;
        } else {
          this.disableOrEnablePregnantField(control, index, false);
        }
      }
      const formCtrls = <FormArray>this.dynamicForm.controls[`applicant${index}`];
      conditional_ctrl_value = this.getControlValue(formCtrls, control.conditional_details.conditional_name) || null;

      //Checking Conditional value
      if (conditional_ctrl_value && this.checkString(conditional_ctrl_value) == this.checkString(control.conditional_details.conditional_value)) {
        return true;
      } else {
        let values = this.dynamicForm.get(`applicant${index}`)?.value;
        // values[controlIndex][control.name] = 'NA';
        const formCtrls = <FormArray>this.dynamicForm.controls[`applicant${index}`];
        var arrayControl = formCtrls.controls[controlIndex] as FormArray;
        //Resetting Form Validators
        //Setting initial value to 
        if (control.name == 'pregnant') {
          arrayControl.get(control.name)?.setValue('NA');
        } else {
          arrayControl.get(control.name)?.setValue('');
        }

        arrayControl.get(control.name)?.setErrors(null);
        arrayControl.get(control.name)?.clearValidators();
        arrayControl.get(control.name)?.updateValueAndValidity();
        return false;
      }
    } else {
      if (control.name == 'ischild' && control.has_conditional) {
        let rawValue = this.dynamicForm.getRawValue();
        let applicantObj = Object.assign({}, ...rawValue[`applicant${index}`]);
        let isChildValue = applicantObj['ischild'] instanceof Array == false ? applicantObj['ischild'] : null;
        //Disabling isChild Field for form edit
        if (this.editFormData?.form_elements?.length > 0) {
          const isChildFormControls = <FormArray>this.dynamicForm.controls[`applicant${index}`];
          var isChildArrayControl = isChildFormControls.controls[controlIndex] as FormArray;
          isChildArrayControl.get(control.name)?.disable();
        }
        if (this.checkString(isChildValue) == 'yes') {
          this.dateOfBirths[index].dobMaxDate = new Date(new Date().setDate((new Date().getDate() - 1)));
          this.dateOfBirths[index].dobMinDate = new Date(new Date().setMonth(new Date().getMonth() - (11 * 12)));
        } else if (this.checkString(isChildValue) == 'no') {
          let pregnantFormControls = <FormArray>this.dynamicForm.controls[`applicant${index}`];
          let pregnantIndex = this.jsonFormData.findIndex((el: any) => el.name == 'pregnant');
          let pregnantFieldControl = pregnantFormControls.controls[pregnantIndex] as FormArray;
          this.dateOfBirths[index].dobMaxDate = new Date(new Date().setMonth(new Date().getMonth() - (11 * 12)));
          this.dateOfBirths[index].dobMinDate = '';
        } else {
          if (this.editFormData?.form_elements?.length > 0) {
            let isChildIndex = this.editFormData?.form_elements.findIndex((el: any) => el.field_name == 'ischild');
            if (this.checkString(this.editFormData?.form_elements[isChildIndex].field_value) == 'yes') {
              this.dateOfBirths[index].dobMaxDate = new Date(new Date().setDate((new Date().getDate() - 1)));
              this.dateOfBirths[index].dobMinDate = new Date(new Date().setMonth(new Date().getMonth() - (11 * 12)));
            } else {
              this.dateOfBirths[index].dobMaxDate = new Date(new Date().setMonth(new Date().getMonth() - (11 * 12)));
              this.dateOfBirths[index].dobMinDate = '';
            }
          }
        }
      }
      return true;
    }
  }

  checkString(value: any) {
    if (typeof value == 'string') {
      return value.toLowerCase();
    } else {
      return value;
    }
  }

  getControlValue(formArray: FormArray, controlName: any) {
    var conditionalValue = null;
    var value = formArray.controls.map((ctrls: any) => {
      if (ctrls.get(controlName)?.value) {
        conditionalValue = ctrls.get(controlName)?.value;
      }
    });
    return conditionalValue ?? null;
  }

  getControlNameArray(formArray: FormArray) {
    let controlValues: any = [];
    formArray.controls.forEach(el => controlValues.push(Object.getOwnPropertyNames(el.value)));
    let result = controlValues.flat(1);
    return result;
  }

  getFileExtensions(extensions: string) {
    return extensions.split(',').map(ext => '.' + ext).join(', ');
  }

  viewPdf(url: string) {
    window.open(url, "_blank");
  }

  getEditFileDetails(name: string, condition: string) {
    let fileIndex = this.editFileNames.findIndex((el: any) => el.name == name);
    if (condition == 'fileName') {
      return this.editFileNames[fileIndex].fileName;
    } else if (condition == 'url') {
      return this.editFileNames[fileIndex].url;
    } else if (condition == 'extension') {
      return this.editFileNames[fileIndex].extension;
    } else if (condition == 'isVisible') {
      if (this.editFormData?.form_elements.length > 0) {
        return this.editFileNames[fileIndex].isVisible;
      } else {
        return false;
      }

    }

  }

  getFileName(control: any, index: number) {
    let fileIndex = this.fileNames[index].findIndex((el: any) => el.name == control.name);
    return this.fileNames[index][fileIndex].value;
  }

  getFileValidation(control: any, index: number) {
    let fileIndex = this.fileNames[index].findIndex((el: any) => el.name == control.name);
    return this.fileNames[index][fileIndex].isValidSize;
  }

  getConditionalValidation(control: any, index: number) {
    let conditionalIndex = this.conditionalFields[index].findIndex((el: any) => el.name == control.name);
    return this.conditionalFields[index][conditionalIndex].isVisible;
  }

  createFileArray() {
    let attachmentArray = this.jsonFormData.map(el => el.type == 'file' ? el.name : null).filter(x => x);
    let fileObj: any = [];
    attachmentArray.forEach((element: any) => {
      fileObj.push({
        name: element,
        value: '',
        isValidSize: false
      });
    });
    this.fileNames = Array.from({ length: +this.totalCount }).map(el => fileObj);
  }

  createConditionalFieldArray() {
    let conditionalArray = this.jsonFormData.filter(el => el.is_conditional);
    let conditionObj: any = [];
    conditionalArray.forEach((element: any) => {
      conditionObj.push({
        name: element.name,
        conditional_name: element.conditional_details.conditional_name,
        conditional_value: element.conditional_details.conditional_value,
        isVisible: false
      });
    });
    this.conditionalFields = Array.from({ length: +this.totalCount }).map(el => conditionObj);
  }

  createFormArray() {
    this.countArray.forEach((element: any, index: any) => {
      this.dynamicForm.addControl(
        `applicant${index}`,
        this.fb.array([])
      );
    });
    this.jsonFormData.forEach((el: JsonFormControls, ctrlIndex: number) => {
      if (el.is_dynamic) {
        this.apiService.getDynamicUrlContent(el.dynamic_url!).subscribe({
          next: (data: any) => {
            if (data['success']) {
              el.values = data.data;
              if (this.editFormData?.form_elements.length > 0) {
                let formCtrl = <FormArray>this.dynamicForm.get('applicant0');
                let fieldCtrl = formCtrl.controls[ctrlIndex] as FormArray;
                let formControlCheck = this.editFormData.form_elements.filter((editElement: any) => editElement.field_name == el.name);
                let categoryExist = data.data.filter((categoryEl: any) => categoryEl.value == this.editFormData.form_elements[ctrlIndex].field_value);
                if (formControlCheck.length > 0) {
                  if (categoryExist.length > 0) {
                    fieldCtrl.patchValue(this.getEditValue(el.name, this.editFormData.form_elements[ctrlIndex].field_value));
                  } else {
                    fieldCtrl.patchValue(this.getEditValue(el.name, ''));
                  }

                }
              }
            } else {
              el.values = [];
            }
          },
          error: (e: any) => {
            el.values = [];
          }
        });
      }
    });
    this.createForm(this.jsonFormData);
  }

  createDobArray() {
    this.countArray.forEach((element: any) => {
      this.dateOfBirths.push({
        dobMaxDate: new Date(new Date().setDate((new Date().getDate() - 1))),
        dobMinDate: ''
      });
    });
  }

  checkPassportExpiration() {
    this.jsonFormData.forEach(el => {
      if (el.expiration_details) {
        if (el.expiration_details?.expiration_type == 'month') {
          this.passportMinDate = new Date(new Date().setMonth(new Date().getMonth() + el.expiration_details.expiration_no));
          this.passportMinDate = new Date(this.passportMinDate.setDate(this.passportMinDate.getDate() + 1));
        } else if (el.expiration_details?.expiration_type == 'year') {
          this.passportMinDate = new Date(new Date().setMonth(new Date().getMonth() + (el.expiration_details.expiration_no * 12)));
          this.passportMinDate = new Date(this.passportMinDate.setDate(this.passportMinDate.getDate() + 1));
        }
      }
    });
  }

  ngOnInit() {
    this.countArray = this.counter(+this.totalCount);
    this.bookingDetails = JSON.parse(this.storage.get('booking_details') || '{}');
    this.createFileArray();
    this.createConditionalFieldArray();
    this.createFormArray();
    this.createDobArray();
    this.checkPassportExpiration();
  }

}
